import BackendQuery from 'decentralized/BackendQuery.js';
import accounts from "accounts/Accounts.js"
import ethereum from 'decentralized/ethereum.js';
import {decryptResults} from 'decentralized/guilds/queryDecryptor.js';
import GuildPresetsContract from 'decentralized/contracts/GuildPresetsContract.js';
import {
    NewPreset2,
    PresetTag,
    PresetSample,
    PresetInstrumentType
} from 'decentralized/EthereumEvents.js';
import {web3} from 'decentralized/web3.js';


const contract = new GuildPresetsContract();

let cache = {};

export const searchPresets = async (user, instrumentType, tags, guildId=0, fromBlock, filterFavorites, contentHashes, searchTerm) => {
    let key = instrumentType + '.' + guildId + '.' + filterFavorites + contentHashes;
    /*
    if (key in cache) {
        return cache[key];
    }
    */
    return new Promise(async (resolve) => {
        let user = await accounts.getAccount();
        let body = {
            instrumentType,
            guildId,
            contentHashes,
            user,
            filterFavorites,
        };
        if (searchTerm) {
            body.searchTerm = searchTerm;
        }
        fetch('/presetSearch/' , {
                method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(resp => resp.json())
            .then(async resp => {
                if (guildId != 0) {
                    resp = await decryptResults(resp, guildId);
                }
                resolve(resp);
            });
    });

    return
    

    let instQuery= new BackendQuery(contract.contractAddress)
        .from(PresetInstrumentType)
        .select('contentHash')
        .where('instrumentType', instrumentType);

    let instResults = (await instQuery.executeQuery())
        .map(x => x.contentHash);
    if (contentHashes) {
        instResults = instResults.filter(x => contentHashes.includes(x));
    }

    if (filterFavorites) {
        instResults = await getFavoritePresets(instResults);
    }

    let query = new BackendQuery(contract.contractAddress)
        .from(NewPreset2)
        .select('user')
        .select('encryptedName')
        .select('contentHash')
        .select('encryptedContentKey')
        .select('publicKey')
        .select('guildId')
        .whereIn('contentHash', instResults)
        .where('guildId', guildId);

    if (fromBlock) {
        query.fromBlock(fromBlock);
    }

    let encryptedResults = await query.executeQuery();
    let results = await decryptResults(encryptedResults, guildId);
    results = results.filter(x => x.title); // must have a title
    let tagResults = await getTagsForPresets(results.map(x => x.contentHash));
    let filteredResults = [];
    let idToResult = {};
    for (let result of results) {
        result.tags = Array.from(
            new Set(
                tagResults.filter(r => r.contentHash === result.contentHash)
                    .map(x => x.tag)));
        idToResult[result.contentHash] = result;
    }
    let _results = Object.values(idToResult);
    cache[key] = _results;
    return _results;
};

const getTagsForPresets = async (hashes) => {
    let query = new BackendQuery(contract.contractAddress)
        .from(PresetTag)
        .select('contentHash')
        .select('tag')
        .whereIn('contentHash', hashes);

    return await query.executeQuery();
};

const getFavoritePresets = async (ids) => {
    let user = await accounts.getAccount();
    return await ethereum.xanadu.getSoundsWithRating(
        ids, 5, user);
};

export const getPresetsData = async (hashes, guildId=0) => {
   let query = new BackendQuery(contract.contractAddress)
        .from(NewPreset2)
        .whereIn('contentHash', hashes);

    let results = await decryptResults(await query.executeQuery(), guildId);
    return results;
};

export const clearCache = () => cache={};
